// extracted by mini-css-extract-plugin
module.exports = {"blueColor":"#3f52ff","container":"InsightsLineChart_container__3pSGJ"};